
import {LOAD_AVAILABLECALCS, LOAD_CALC, LOAD_AVAILABLEDATES, LOAD_CHECK} from './settings'

const initState = {
	openMessage: false,
	message: undefined,
	error: false,
	to: undefined,
}

const MESSAGE_SHOW = 'MESSAGE_SHOW'
const MESSAGE_HIDE = 'MESSAGE_HIDE'
const UPDATE_TO = 'UPDATE_TO'

export const ERROR_HOME = 'ERROR_HOME'
export const ERROR_LOAD = 'ERROR_LOAD'

export const showMessage = (msg) => ({type: MESSAGE_SHOW, payload: msg})
export const hideMessage = () => ({type: MESSAGE_HIDE})
export const UpdateTo = (msg) => ({type: UPDATE_TO, payload: msg})
export const errorHome = (msg) => ({type: ERROR_HOME, payload: msg})
export const errorLoad = (msg) => ({type: ERROR_LOAD, payload: msg})

export default function(state=initState, action){
	switch(action.type){
		case MESSAGE_SHOW:
			return {...state, openMessage: true, message: action.payload}
		case LOAD_AVAILABLEDATES:
		case LOAD_CALC:
		case MESSAGE_HIDE:
			return {...state, error: false, openMessage: false, message: undefined}
		case UPDATE_TO:
			return {...state, to: action.payload}
		case LOAD_AVAILABLECALCS:
		  return {...state, openMessage: false, message: undefined, to: '/search'}
		case ERROR_LOAD:
		case ERROR_HOME:
			return {...state, error: true, openMessage: true, message: action.payload}
		case LOAD_CHECK:
			if (action.payload.response === 'completed'){
				return {...state, error: false, openMessage: false, message: undefined, to: '/confirmation'}
			}
		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/shared/routers/messages.js